function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M42.5-709.5a7.714 7.714 0 0 1-5.667-2.334A7.718 7.718 0 0 1 34.5-717.5a7.711 7.711 0 0 1 2.333-5.666A7.718 7.718 0 0 1 42.5-725.5h13.035a7.714 7.714 0 0 1 5.667 2.334 7.718 7.718 0 0 1 2.333 5.668 7.711 7.711 0 0 1-2.333 5.666 7.718 7.718 0 0 1-5.667 2.332zm13.065-4.709a3.178 3.178 0 0 0 2.332-.959 3.169 3.169 0 0 0 .961-2.33 3.178 3.178 0 0 0-.959-2.332 3.169 3.169 0 0 0-2.33-.961 3.178 3.178 0 0 0-2.332.959 3.169 3.169 0 0 0-.961 2.33 3.179 3.179 0 0 0 .959 2.332 3.169 3.169 0 0 0 2.33.961z",
  transform: "translate(-34.5 725.5)"
});

function SvgToggleOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.035 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOn);
export default __webpack_public_path__ + "static/media/toggle-on.26b5f5dc.svg";
export { ForwardRef as ReactComponent };